import { filesUrl } from "./Helpers/Config";
import { Card } from "../pages/Theme";

function convertToEmbeddedURL(url) {
    // Regular expression to match YouTube video URLs
    // var youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?youtu(?:be\.com\/(?:watch\?v=|embed\/|v\/)|\.be\/)([\w\-_]+)(?:\S+)?$/;
    var youtubeRegex = /^(?:(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:watch\?.*v=|embed\/|v\/|shorts\/)|https?:\/\/youtu\.be\/|https?:\/\/www\.youtube\.com\/playlist\?list=)([\w-]{11})/;
    var match = url.match(youtubeRegex);
    if (match && match[1]) {
        var videoId = match[1];
        return 'https://www.youtube.com/embed/' + videoId;
    }

    return url;
}

//   // Example usage
//   var sourceURL = 'https://www.youtube.com/watch?v=VIDEO_ID';
//   var embeddedURL = convertToEmbeddedURL(sourceURL);

export const VideoTrack = ({ data }) => {

    return (<>
        <Card className="relative card-video cardBackgroundColor shadow-sm border20px">
            {data?.video_path &&
                <div>
                    <video class="h-full w-full" width="" height="" controls="controls" src={filesUrl + data?.video_path}>
                    </video>
                </div>
            }
            {data?.video_link &&
                <div class="">
                    <iframe class="h-full w-full" src={convertToEmbeddedURL(data?.video_link)} allowfullscreen>
                    </iframe>
                </div>
            }
            {data?.video_name &&
                <div className="pt-3 font-bold blackColor text-base">
                    {data?.video_name}
                </div>
            }
            {data?.video_desc &&
                <div className="pt-1 lightColor text-sm">
                    {data?.video_desc}
                </div>
            }
        </Card>
    </>)
}
